import '@babel/polyfill';
import '@assets/vendor/jquery';
import '@project/vendor/bootstrap';

import Cookie from '@assets/components/cookie';
import ConsentTracking from '@assets/components/consentTracking';
import Footer from '@assets/components/footer';
import Breakpoints from '@assets/utils/breakpoints';
import Events from '@assets/utils/events';
import Viewport from '@assets/utils/viewport';
import Resource from '@assets/utils/resource';
import ToolTip from '@project/components/toolTip';
import Newsletter from '@project/components/newsletter';
import PrivacyForm from '@project/components/privacyForm';
import triggerSizeChartModal from '@project/components/triggerSizeChartModal';
import WishlistHeart from 'wishlistcustom/product/wishlistHeart';
import { customSelectEvents } from '@project/components/customSelect';
import einsteinCookies from '@project/components/einsteinCookies';
import { itemSelect } from '@project/components/gtmUtils';
import { triggerRedirectCountryModal, onExternalSiteRedirectModal, blurOnModalHide } from '@project/components/utility';
import NoShoppableModal from '@project/components/noShoppableModal';
import NoShippingModal from '@project/components/noShippingModal';
import ClientSideValidation from './components/clientSideValidation';
import CollapsibleItem from './components/collapsibleItem';
import Search from './components/search';
import MiniCart from './components/miniCart';

import Spinner from './components/spinner';
import Menu from './components/menu';
import CountrySelector from './components/countrySelector';
import togglePasswordVisibility from './components/formComponents/togglePasswordVisibility';

document.addEventListener('DOMContentLoaded', () => {
    const menu = new Menu();
    const spinner = new Spinner();
    const cookie = new Cookie();
    const consentTracking = new ConsentTracking();
    const footer = new Footer();
    const miniCart = new MiniCart();
    const collapsibleItem = new CollapsibleItem();
    const search = new Search();
    const clientSideValidation = new ClientSideValidation();
    const toolTip = new ToolTip();
    const countrySelector = new CountrySelector();
    const newsletter = new Newsletter();
    const privacyForm = new PrivacyForm();

    window.breakpoints = new Breakpoints();
    window.events = new Events();
    window.viewport = new Viewport();

    menu.init();
    spinner.init();
    cookie.init();
    consentTracking.init();
    footer.init();
    miniCart.init();
    collapsibleItem.init();
    search.init();
    clientSideValidation.init();
    toolTip.init();
    countrySelector.init();
    newsletter.init();
    privacyForm.init();

    if (Resource.getSitePreference('wishlist', 'sfraEnableOverlayWishlist')) {
        const wishlistHeart = new WishlistHeart();
        wishlistHeart.init();
    }

    if (Resource.getSitePreference('storefront', 'isNonShoppable')) {
        const noShoppableModal = new NoShoppableModal();
        noShoppableModal.init();
    }

    const noShippingModal = new NoShippingModal();
    noShippingModal.init();

    einsteinCookies();
    triggerSizeChartModal();
    itemSelect(window.listID);
    customSelectEvents();
    togglePasswordVisibility();
    triggerRedirectCountryModal();
    onExternalSiteRedirectModal();
    blurOnModalHide();
});
